import classNames from "classnames";
import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { EditPlay, PlayTable, useEditPlay } from "../../components";
import { useDefaultPlayData } from "../../hooks/use-default-play-data";
import { useCreatePlayMutation, useGetSinglePlay } from "../../redux/slices";
import { SportPlay } from "../../types";
import styles from "./draw.module.scss";
import { PlayViewer } from "./play-viewer";

export const Draw = () => {
  const navigate = useNavigate();

  /** ======== Plays ======== */
  const [activePlayId, setActivePlayId] = useState<string>();
  const { data: activePlay, isFetching: isFetchingActivePlay } = useGetSinglePlay(activePlayId);

  /** ======== Edit Play Meta Data ======== */
  const { getDefaultPlayData } = useDefaultPlayData();
  const [createPlay] = useCreatePlayMutation();

  const editPlayProps = useEditPlay();
  const { showEditPlay } = editPlayProps;

  const openEditPlayDetails = (play: SportPlay) => {
    showEditPlay(play);
  };

  const [creatingPlay, setCreatingPlay] = useState<boolean>(false);

  const handleClickCreatePlay = async () => {
    const playData = getDefaultPlayData();
    try {
      setCreatingPlay(true);
      const newPlayResponse = await createPlay({ play: playData }).unwrap();
      setCreatingPlay(false);
      setActivePlayId(newPlayResponse.id || "");
      navigate(`/plays/${newPlayResponse.id}`);
    } catch (err) {
      setCreatingPlay(false);
      console.error(err);
    }
  };

  /** ======== Play Tab Editor ======== */
  const handleClickEditPlay = () => {
    if (activePlayId) {
      navigate(`/plays/${activePlayId}`);
    }
  };

  useEffect(() => {
    // Extract the hash parameters from the URL
    const hashParams = queryString.parse(window.location.hash);

    // Access the specific parameter
    const playId = hashParams.playId;
    setActivePlayId(playId as string);
  }, []);

  const isAccessedViaIframe = window.self !== window.top;

  return (
    <div className={classNames(styles.draw, { [styles.drawIframe || ""]: isAccessedViaIframe })}>
      <div className={styles.drawLeftContent}>
        <PlayTable
          activePlayId={activePlayId}
          setActivePlayId={setActivePlayId}
          openPlayTab={handleClickEditPlay}
          openEditPlayDetails={openEditPlayDetails}
          creatingPlay={creatingPlay}
          handleClickCreatePlay={handleClickCreatePlay}
        />
      </div>
      <div className={styles.drawRightContent}>
        <div className={styles.rightContentContainer}>
          <PlayViewer
            activeDrawPlay={activePlay}
            isLoading={isFetchingActivePlay}
            handleClickEditPlay={handleClickEditPlay}
          />
        </div>
      </div>
      <EditPlay {...editPlayProps} />
    </div>
  );
};
